/* src/app/style/side-menu.responsive.scss */
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) and (device-aspect-ratio: 2/3) {
  .app-sidemenu .user-info-wrapper .user-name {
    font-size: 18px;
  }
  .app-sidemenu ion-list ion-item {
    font-size: 14px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (device-aspect-ratio: 40/71) {
  .interests-to-follow-slide .custom-checkbox .checkbox-title {
    font-size: 18px;
  }
}
/*# sourceMappingURL=side-menu.responsive.css.map */
